module.exports = __webpack_public_path__ + "img/matrix_item.8b3066e1.png";